export default {"src":"/_next/static/media/usdc.e1142931.svg","height":24,"width":24};